<template>
<m-pageframe
    title="Account Change Log: {organization_label}"
>
<v-container
    fluid
    style="padding-top: 15px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-template
        v-if="filtered"
    >
        <v-alert
            border="left"
            colored-border
            color="primary"
            elevation="2"
            type="info"
        >
            Results are being

            <v-tooltip
                top
            >
                <template v-slot:activator="{ on, attrs }">
                    <span
                        v-bind="attrs"
                        v-on="on"
                        class="text-decoration-underline"
                    >filtered</span>

                </template>

                <span>subject_uuid = '{{ this.$route.query.subject_uuid }}'</span>
            </v-tooltip>

            <span>.</span>
            <a @click="clearFilter"> Click Here</a> to see all results.
            <!-- <span class="font-weight-medium">subject_uuid = '{{ this.$route.query.subject_uuid }}'</span> -->
        </v-alert>
    </v-template>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time, 'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time, 'time')}}
        </template>

        <template v-slot:item.type_operation="{ item }">
            {{$rc.pretty(item.type_operation, 'enum_account_log_entry_operation_type')}}
        </template>

        <template v-slot:item.type_object="{ item }">
            {{$rc.pretty(item.type_object, 'enum_account_log_entry_object_type')}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickTechnicalDetails(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,

            headers: [
                { text: 'Date', value: 'time_date' },
                { text: 'Time', value: 'time_time' },
                { text: 'By', value: 'by_employee_label' },
                { text: 'Operation', value: 'type_operation' },
                { text: 'Type', value: 'type_object' },
                { text: 'Subject', value: 'subject_label' },
                { text: 'Description', value: 'description' },
                { text: 'Action', value: 'action' },
            ],

            results: [],
        }
    },


    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/account-log',
            
                'params' : {
                        'full_text': this.full_text,
                        'organization_id': this.$route.params.organization_id,
                        'subject_uuid': this.$route.query.subject_uuid
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to search account log',
            });
        },

        onClickTechnicalDetails(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/account-log/technical-details/:entry_id',
            
                'params' : {
                        'entry_id': item.entry_id,
                    },
            
                'on_success': (data) => {
                        this.$rc.technicalDetails({
                            'title': 'Technical Details',
                            'technical_details': data,
                        });
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },
        
        clearFilter() {
            this.$router.replace({'query.subject_uuid': undefined});
            this.doUpdate();
        },
    },

    computed: {
        filtered() {
            return null != this.$route.query?.subject_uuid;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>

